import { render } from "./DashboardFinancieroView.vue?vue&type=template&id=568ade8f&scoped=true"
import script from "./DashboardFinancieroView.vue?vue&type=script&lang=js"
export * from "./DashboardFinancieroView.vue?vue&type=script&lang=js"

import "./DashboardFinancieroView.vue?vue&type=style&index=0&id=568ade8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568ade8f"]])

export default __exports__